import React, { Component } from 'react'
import { Droppable } from 'react-beautiful-dnd'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import DraggableHeading from './DraggableHeading'

@observer
class DroppableMergeField extends Component {
    render() {
        const { title, droppableId, columns, removeItem, removeQuestion, colId } = this.props
        return (
            <div className="droppable-mergefield-area">
                <div className="droppable-mergefield-content">
                    <div className="droppable-mergefield-title">
                        {title}
                    </div>

                    <div style={{ width: '100%' }}>
                        <Droppable style={{ width: 'inherit', height: 'inherit' }} isDropDisabled={false} test={1} droppableId={droppableId}>
                            {(provided) => (
                                <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    className="droppable-mergefield-droppable-content"
                                >
                                    {columns.map((heading, index) => (
                                        <DraggableHeading heading={heading} index={index} removeItem={removeItem} column={title}/>
                                    ))}
                                    <p className="droppable-mergefield-droppable-placeholder">{i18n.t('distributionEmailList.dragHeading')}</p>
                                </div>
                            )}
                        </Droppable>
                    </div>
                    {removeQuestion && colId && (
                        <i
                            className="fal fa-times-circle column-remove"
                            onClick={removeQuestion}
                            data-droppableId={droppableId}
                            data-columnId={colId}
                        />
                    )}
                </div>
            </div>
        )
    }
}

export default DroppableMergeField
